/**
 * Onboarding Form user — Tasks tab (role === 'onboarding_form').
 * Master Forms assigned to the logged-in user: Assigned / Pending / Completed
 * tabs, Today/All, Start + Remarks. Completion is automatic when the Master
 * Form is submitted and the Property is created (see backend Phase 5).
 */
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import DateRangeFilter from '../../components/DateRangeFilter';
import MasterFormSection from '../../components/masterform/MasterFormSection';

const OnboardingFormTasks = () => {
  const [searchParams] = useSearchParams();
  const [range, setRange] = useState(searchParams.get('range') || 'all');
  const [customFrom, setCustomFrom] = useState(searchParams.get('start') || '');
  const [customTo, setCustomTo] = useState(searchParams.get('end') || '');
  const initialTab = searchParams.get('tab') || 'assigned';

  return (
    <div className="space-y-6" data-testid="onboarding-form-tasks">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 px-5 py-4">
        <h2 className="text-xl font-bold text-gray-800">My Master Forms</h2>
        <p className="text-sm text-gray-500 mt-0.5">Follow up with owners and get the Master Form submitted. Tasks auto-complete once the Property is created.</p>
      </div>
      <DateRangeFilter value={range} onChange={setRange} customFrom={customFrom} customTo={customTo}
        onCustomFrom={setCustomFrom} onCustomTo={setCustomTo} testId="of-tasks-date-filter" />
      <MasterFormSection mode="user" range={range} customFrom={customFrom} customTo={customTo}
        initialTab={initialTab} testId="of-tasks" />
    </div>
  );
};

export default OnboardingFormTasks;
